import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import swal from "sweetalert";
import axios from "axios";
import ImageModal from "./Image";

const Banner = () => {
  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [allbanner, Updatebanner] = useState([]);
  const [fullname, pickName] = useState("");
  const [img, pickImg] = useState("");


  const baseurl = "https://apimlm.bloomitsolutions.in";

  const getBanner = async () => {
    try {
      const response = await axios.get(
        "https://apimlm.bloomitsolutions.in/contentroutes/getAllBanners"
      );
      Updatebanner(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  const save = async () => {
    try {
      let formData = new FormData();
      formData.append("bannertitle", fullname);
      formData.append("image", img);
      

      await axios.post(
        "https://apimlm.bloomitsolutions.in/contentroutes/uploadBanner",
        formData
      );
      swal(fullname, "Saved Successfully", "success");
      getBanner();
      handleClose();
    } catch (error) {
      console.error("Error:", error);
      swal("Error", "Failed to save data: " + error.message, "error");
    }
  };


  const deletebanner = async (id) => {
    try {
      const response = await axios.delete(
        `https://apimlm.bloomitsolutions.in/contentroutes/deleteBanner?id=${id}`
      );
      if (response.status == 201) {
        swal("Success", response.data.message, "success");
        //refresh page
        window.location.reload();
        getBanner();
      } else {
        throw new Error(
          "Failed to delete data. Server returned unexpected response: " +
            JSON.stringify(response.data)
        );
      }
    } catch (error) {
      console.error("Error:", error);
      swal("Error", "Failed to delete data: " + error.message, "error");
    }
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [enlargedImageUrl, setEnlargedImageUrl] = useState("");


  const openImageModal = (imageUrl) => {
    setEnlargedImageUrl(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setEnlargedImageUrl("");
    setShowImageModal(false);
  };

 

  return (
    <section>
      <div className="container-fluid contmar">
        <div className="row">
          <div className="col-lg-1 text-end">
            <Link to="/">
              <h6>
                <i class="fa fa-home" aria-hidden="true"></i>Home
              </h6>
            </Link>
          </div>
          /
          <div className="col-lg-5">
            <h6>Banner</h6>
          </div>
          <div className="col-lg-10 mt-3 mb-3">
            <div className="card border-0 shadow ">
              <div className="card-header bg bg-info border-0">
                <h4>List Of Banner</h4>
              </div>

              <div className="card-body">
                <div className="col-lg-12 ">
                  <div className="row text-end">
                    <div className="col-lg-6"></div>
                    <div className="col-lg-3"></div>

                    <div className="col-lg-3">
                      <button
                        className="btn btn-success"
                        variant="primary"
                        onClick={handleShow}
                      >
                         New Banner
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 mt-3">
                  <div class="table-responsive">
                    <table class="table table-bordered  mb-0 text-nowrap">
                      <thead>
                        <tr>
                          <th> ID </th>
                          <th>Banner Name</th>
                          <th> Image</th>
                          <th> Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {allbanner.map((banner, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>

                              <td>{banner.bannertitle}</td>
                              <td>
                                <img 
                                  src={`${baseurl}/${banner.bannerImage}`}
                                  style={{
                                    maxWidth: "100px",
                                    maxHeight: "100px",
                                  }}
                                  onClick={() => openImageModal(`${baseurl}/${banner.bannerImage}`)}

                                />
                              </td>
                             
                              <td>
                               

                                <button
                                  onClick={deletebanner.bind(
                                    this,
                                    banner.id,
                                    banner.bannertitle
                                  )}
                                  className="btn btn-danger"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {/ ========================modal start=============== /} */}

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Add Banner</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Banner Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Banner Name"
                onChange={(e) => pickName(e.target.value)}
                value={fullname}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                placeholder="Enter url"
                onChange={(e) => pickImg(e.target.files[0])}
               
              />
            </Form.Group>

           


          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                save();
                handleClose();
              }}
            >
              save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {showImageModal && (
        <ImageModal
          isOpen={showImageModal}
          onRequestClose={closeImageModal}
          imageUrl={enlargedImageUrl}
        />
      )}
    </section>
  );
};

export default Banner;